


















import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import Drawer from './components/Drawer.vue';
import Navbar from './components/Navbar.vue';

@Component({ components: { Drawer, Navbar } })
export default class App extends Vue {
  @State('isAuthenticating')
  public isAuthenticating!: boolean;

  @State('loading')
  public loading!: boolean;

  private showDrawer = false;

  public openDrawer() {
    this.showDrawer = true;
  }

  public toggleDrawer(showDrawer: boolean) {
    this.showDrawer = showDrawer;
  }
}
